import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from '../../utility/helpers';

function ProtectedRoute({ Component }) {
  const token = getToken();
  return token ? <Component /> : <Navigate to="/app/auth" />;
}

export default ProtectedRoute;
